export const linkStateStyles = (baseColor, { useDefault = true, ...stateStylesObject } = {}) => {
  const states = ['visited', 'focus', 'hover', 'active']
  const colorStyle = { color: baseColor }

  let styles = { ...colorStyle }
  for (const state of states) {
    const stateStyles = stateStylesObject[state]

    styles = {
      ...styles,
      ...((stateStyles || useDefault) && {
        [`&:${state}`]: {
          ...(useDefault && colorStyle),
          ...stateStyles
        }
      })
    }
  }

  return { ...styles }
}

export const respondTo = ({ device, styles = {}, size = 'min' } = {}) => {
  const breakpoints = {
    mobile: { min: '480px', max: '599px' },
    smallTablet: { min: '600px', max: '767px' },
    tablet: { min: '768px', max: '991px' },
    desktop: { min: '992px', max: '1199px' },
    largeDesktop: { min: '1200px', max: '1599px' }
  }

  if (!Object.keys(breakpoints).includes(device)) return

  const deviceBreakpoint = breakpoints[device][size]

  return {
    [`@media screen and (${size}-width: ${deviceBreakpoint})`]: {
      ...styles
    }
  }
}

export const getTheme = (theme) => {
  const overflowOverride = {
    ...theme.elements.hero.wrapper,
    overflow: 'visible'
  }

  return { ...theme, elements: { ...theme.elements, hero: { ...theme.elements.hero, wrapper: overflowOverride } } }
}
